import { createScopedReducer } from '@mews-commander/utils';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import { RESOURCES_FETCH_STARTED, RESOURCES_FETCH_FAILED, RESOURCES_FETCH_SUCCEEDED } from '../../actionTypes';

export const NAME = 'resources';

export const resourcesReducer = createScopedReducer(META_STATE_SUCCEEDED, {
    ...createEntityAsyncMetaHandlers({
        STARTED: RESOURCES_FETCH_STARTED,
        SUCCEEDED: RESOURCES_FETCH_SUCCEEDED,
        FAILED: RESOURCES_FETCH_FAILED,
    }),
});
